import { action } from 'mobx'
import axios from "axios/index";
import {Common as util} from "../utils/common";
import gql from "../utils/gql";



export class Review {

    @action fixReviewContents = (data, cb) => {

        let property = ['store_id', 'review_id', 'contents'];
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'mutation',
            operation: 'fixReviewContents',
            variables: variables,
            getData: 'data'
        };
        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                // GraphQL 표준 errors는 res.data.errors, mutation 결과는 res.data.data[operation]
                if (res.data && res.data.errors && res.data.errors.length > 0) {
                    const result = {data: null, errors: res.data.errors};
                    if(typeof cb === 'function') { cb(result); }
                    else { return result; }
                    return;
                }
                const result = res.data.data[params.operation] || {data: null};
                if(typeof cb === 'function') { cb(result); }
                else { return result; }
            })
            .catch(function (error) {
                if(typeof cb === 'function') { cb(error); }
                return error;
            });
    };

    @action reorderFixedReviews = (data, cb) => {
        let property = ['store_id', 'shopNo', 'platformProductId', 'orderedIds'];
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'mutation',
            operation: 'reorderFixedReviews',
            variables: variables,
            getData: 'data'
        };
        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if (res.data && res.data.errors && res.data.errors.length > 0) {
                    const result = {data: null, errors: res.data.errors};
                    if(typeof cb === 'function') { cb(result); } else { return result; }
                    return;
                }
                const result = res.data.data[params.operation] || {data: null};
                if(typeof cb === 'function') { cb(result); } else { return result; }
            })
            .catch(function (error) {
                if(typeof cb === 'function') { cb(error); }
                return error;
            });
    };

    @action getFixedReviewGroupsByProduct = (data, cb) => {
        let property = ['store_id', 'shopNo', 'page', 'limit'];
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'query',
            operation: 'getFixedReviewGroupsByProduct',
            variables: variables,
            getData: 'data'
        };
        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if (res.data && res.data.errors && res.data.errors.length > 0) {
                    const result = {data: null, errors: res.data.errors};
                    if(typeof cb === 'function') { cb(result); } else { return result; }
                    return;
                }
                const result = res.data.data[params.operation] || {data: null};
                if(typeof cb === 'function') { cb(result); } else { return result; }
            })
            .catch(function (error) {
                if(typeof cb === 'function') { cb(error); }
                return error;
            });
    };

    @action fixReviewStarRating = (data, cb) => {
        let property = ['review_id', 'goodsPt', 'deliveryPt'];
        let variables = util.getDataStByKey(data, property);
        let params = {
            type: 'mutation',
            operation: 'fixReviewStarRating',
            variables: variables,
            getData: 'data'
        };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams)
            .then(function (res) {
                if (res.data && res.data.errors && res.data.errors.length > 0) {
                    const result = {data: null, errors: res.data.errors};
                    if (typeof cb === 'function') { cb(result); }
                    else { return result; }
                    return;
                }
                const result = res.data.data[params.operation] || {data: null};
                if (typeof cb === 'function') { cb(result); }
                else { return result; }
            })
            .catch(function (error) {
                if (typeof cb === 'function') { cb(error); }
                return error;
            });
    };

    @action updateReview = (data, cb) => {

        // gql() 빌더가 이미 \n, \r, \t, \\, " 모두 이스케이프 처리하므로
        // 여기서 별도로 escapeGraphQLString 호출 시 이중 이스케이프되어 DB에 리터럴 "\n"이 저장됨

        let params = {
            type: 'mutation',
            operation: 'updateReview',
            variables: data,
            getData: 'data'
        };
        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                // GraphQL 에러 시 data가 null이라 바로 접근하면 throw → catch가 Error 객체를
                // cb에 넘겨 컴포넌트(res.errors/res.data 기대)가 크래시하므로 에러 형태를 유지해 전달
                let result = res.data && res.data.data ? res.data.data[params.operation] : null;
                if(!result && res.data && res.data.errors) {
                    result = { errors: res.data.errors };
                }
                if(typeof cb === 'function') {
                    cb(result);
                }
                else {
                    return result;
                }

            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };

    @action uploadReviewExImgs = (data, cb) => {

        let params = {
            type: 'mutation',
            operation: 'uploadReviewExImgs',
            variables: data,
            getData: 'data'
        };
        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }

            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };

    @action genThumbImg = (data, cb) => {

        let params = {
            type: 'mutation',
            operation: 'genThumbImg',
            variables: data,
            getData: 'data'
        };
        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }

            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };




    @action updateMassReview = (data, cb) => {

        let params = {
            type: 'mutation',
            operation: 'updateMassReview',
            variables: data,
            getData: 'data'
        };
        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }

            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };



    @action updateReviewSome = (data, cb) => {

        let params = {
            type: 'mutation',
            operation: 'updateReviewSome',
            variables: data,
            getData: 'data'
        };

        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }

            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };

    @action updateReviewDisplayStatus = (data, cb) => {

        let params = {
            type: 'mutation',
            operation: 'updateReviewDisplayStatus',
            variables: data,
            getData: 'data'
        };
        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }

            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };



    @action updatePayMileage = (data, cb) => {

        let params = {
            type: 'mutation',
            operation: 'updatePayMileage',
            variables: data,
            getData: 'data'
        };
        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }

            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };

    @action updateMileage = (data, cb) => {

        let params = {
            type: 'mutation',
            operation: 'updateMileage',
            variables: data,
            getData: 'data'
        };
        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }

            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };

    @action updateUserOrderByCafe24 = (data, cb) => {

        let params = {
            type: 'mutation',
            operation: 'updateUserOrderByCafe24',
            variables: data,
            getData: 'data'
        };
        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }

            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };




    @action updateReviewComment = (data, cb) => {

        let params = {
            type: 'mutation',
            operation: 'updateReviewComment',
            variables: data,
            getData: 'data'
        };
        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }

            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };

    @action genAIComment = (data, cb) => {

        let params = {
            type: 'mutation',
            operation: 'genAIComment',
            variables: data,
            getData: 'data'
        };
        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(res.data.errors && res.data.errors.length > 0) {
                    res.data.data[params.operation] = {error : res.data.errors[0]};
                }
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }

            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };

    @action commentSmartCorrent = (data, cb) => {
        data.comment = util.escapeGraphQLString(data.comment);

        let params = {
            type: 'mutation',
            operation: 'commentSmartCorrent',
            variables: data,
            getData: 'data'
        };
        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(res.data.errors && res.data.errors.length > 0) {
                    res.data.data[params.operation] = {error : res.data.errors[0]};
                }
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }

            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };

    @action genAITotal = (data, cb) => {

        let params = {
            type: 'mutation',
            operation: 'genAITotal',
            variables: data,
            getData: 'data'
        };
        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(res.data.errors && res.data.errors.length > 0) {
                    res.data.data[params.operation] = {error : res.data.errors[0]};
                }
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }

            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };

    @action genAIReviewAnalysis = (data, cb) => {

        let params = {
            type: 'mutation',
            operation: 'genAIReviewAnalysis',
            variables: data,
            getData: 'data'
        };
        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(res.data.errors && res.data.errors.length > 0) {
                    res.data.data[params.operation] = {error : res.data.errors[0]};
                }
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }

            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };

    @action selectAnalysisProductReview = (data, cb) => {

        let params = {
            type: 'mutation',
            operation: 'selectAnalysisProductReview',
            variables: data,
            getData: 'data'
        };
        const gpqParams = gql(params);

        axios.post('/', gpqParams)
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }

            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };


    @action updateAnalysisProductReview = (data, cb) => {

        let params = {
            type: 'mutation',
            operation: 'updateAnalysisProductReview',
            variables: data,
            getData: 'data'
        };
        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }

            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };

    @action removeReviewMany = (data, cb) => {

        let params = {
            type: 'mutation',
            operation: 'removeReviewMany',
            variables: data,
            getData: 'data'
        };
        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }

            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };

    @action removeAnalysisProductReview = (data, cb) => {

        let params = {
            type: 'mutation',
            operation: 'removeAnalysisProductReview',
            variables: data,
            getData: 'data'
        };
        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }

            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };

    @action getAnalysisList = (data, cb) => {

        let property = ['store_id', 'shopNo', 'product_id', 'limit', 'page', 'sort', 'searchParams'];
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'query',
            operation: 'getAnalysisList',
            variables: variables,
            getData: 'docs, totalDocs, limit, page, nextPage, prevPage, totalPages, pagingCounter, meta'
        };

        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(res.status === 200) {
                    if(typeof cb === 'function') {
                        cb(res.data.data[params.operation]);
                    }
                    else {
                        return res.data.data[params.operation];
                    }
                }

            })
            .catch(function (error) {
                console.log(error);
                return error;
            });
    };


    @action getAnalysisWidgetList = (data, cb) => {

        let property = ['store_id', 'shopNo', 'product_id', 'limit', 'page', 'sort', 'searchParams'];
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'query',
            operation: 'getAnalysisWidgetList',
            variables: variables,
            getData: 'docs, totalDocs, limit, page, nextPage, prevPage, totalPages, pagingCounter, meta'
        };

        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(res.status === 200) {
                    if(typeof cb === 'function') {
                        cb(res.data.data[params.operation]);
                    }
                    else {
                        return res.data.data[params.operation];
                    }
                }

            })
            .catch(function (error) {
                console.log(error);
                return error;
            });
    };



    @action setReviewSync = (data, cb) => {

        let params = {
            type: 'mutation',
            operation: 'setReviewSync',
            variables: data,
            getData: 'data'
        };
        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }

            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };

    // 카페24 게시글에서 특정 리뷰 1건을 다시 가져와 DB 에 반영 (카페24에서 글이 수정된 경우)
    @action reSyncReviewFromCafe24 = (data, cb) => {

        let params = {
            type: 'mutation',
            operation: 'reSyncReviewFromCafe24',
            variables: data,
            getData: 'data'
        };
        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }

            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };

    @action cloudFlareMng = (data, cb) => {

        let params = {
            type: 'mutation',
            operation: 'cloudFlareMng',
            variables: data,
            getData: 'data'
        };
        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }

            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };


    @action getReviewList = (data, cb) => {

        let property = ['store_id', 'limit', 'reviewType', 'page', 'sort', 'displayStatus', 'widget_id', 'searchParams', 'isPopulateProductReply', 'shopNo', 'platformProductId', 'platform'];

        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'query',
            operation: 'getReviewList',
            variables: variables,
            getData: 'docs, totalDocs, limit, page, nextPage, prevPage, totalPages, pagingCounter, meta, refProducts'
        };

        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(res.status === 200) {
                    if(typeof cb === 'function') {
                        cb(res.data.data[params.operation]);
                    }
                    else {
                        return res.data.data[params.operation];
                    }
                }

            })
            .catch(function (error) {
                console.log(error);
                return error;
            });
    };

    @action getSnsFeed = (data, cb) => {

        let property = ['store_id', 'shopNo', 'sns', 'feedType', 'page', 'limit', 'sort', 'order', 'isHidden'];

        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'query',
            operation: 'getSnsFeed',
            variables: variables,
            getData: 'docs, totalDocs, limit, page, nextPage, prevPage, totalPages, pagingCounter'
        };

        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }

            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };

    @action registerSnsFeedsToReview = (data, cb) => {

        let property = ['store_id', 'shopNo', 'snsFeed_Ids', 'productNo', 'reviewDate', 'reviewDefaultContent', 'reviewSnsLabelEnabled', 'reviewSnsLabel'];

        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'mutation',
            operation: 'registerSnsFeedsToReview',
            variables: variables,
            getData: 'data'
        };

        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }

            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };

    @action fetchAndUploadSnsFeed = (data, cb) => {

        let property = ['store_id', 'shopNo'];
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'mutation',
            operation: 'fetchAndUploadSnsFeed',
            variables: variables,
            getData: 'data'
        };

        const gpqParams = gql(params);

        return axios.post('/', gpqParams, { timeout: 300000 })
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }
            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };

    @action uploadSnsFeedImages = (data, cb) => {

        let property = ['store_id', 'shopNo', 'snsFeed_Ids'];
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'mutation',
            operation: 'uploadSnsFeedImages',
            variables: variables,
            getData: 'data'
        };

        const gpqParams = gql(params);

        return axios.post('/', gpqParams, { timeout: 300000 })
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }
            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };

    @action getReviewHistoryList = (data, cb) => {

        let property = ['review_id', 'type']
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'query',
            operation: 'getReviewHistoryList',
            variables: variables,
            getData: 'docs, totalDocs, limit, page, nextPage, prevPage, totalPages, pagingCounter, meta'
        };

        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(res.status === 200) {
                    if(typeof cb === 'function') {
                        cb(res.data.data[params.operation]);
                    }
                    else {
                        return res.data.data[params.operation];
                    }
                }

            })
            .catch(function (error) {
                console.log(error);
                return error;
            });
    };


    @action getReviewMileageInfo = (data, cb) => {

        let property = ['review_id', 'userOrder_id']
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'query',
            operation: 'getReviewMileageInfo',
            variables: variables,
            getData: 'data'
        };
        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation].data;
                }

            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };


    @action getStatusReviewBoard = (data, cb) => {

        let property = ['store_id', 'shopNo', 'platform']
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'query',
            operation: 'getStatusReviewBoard',
            variables: variables,
            getData: 'data'
        };
        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation].data;
                }

            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };


    @action downloadFile = (data, cb) => {

        let variables = data;

        let params = {
            type: 'mutation',
            operation: 'downloadFile',
            variables: variables,
            getData: 'data'
        };
        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(res.status === 200) {
                    if(typeof cb === 'function') {
                        cb(res.data.data[params.operation])
                    }
                    else {
                        return res.data.data[params.operation];
                    }
                }

            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };

    @action adminDelReview = (data, cb) => {

        let variables = data;

        let params = {
            type: 'mutation',
            operation: 'adminDelReview',
            variables: variables,
            getData: 'data'
        };
        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(res.status === 200) {
                    if(typeof cb === 'function') {
                        cb(res.data.data[params.operation])
                    }
                    else {
                        return res.data.data[params.operation];
                    }
                }

            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };

    @action adminReviewImgDomainUpdate = (data, cb) => {

        let property = ['store_id', 'shopNo', 'fromDomain', 'toDomain']
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'mutation',
            operation: 'adminReviewImgDomainUpdate',
            variables: variables,
            getData: 'data'
        };
        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation].data;
                }

            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };


    // ==================== 간편 리뷰 프리셋 API ====================

    @action getQuickReviewPresetList = (data, cb) => {
        let property = ['store_id', 'shopNo', 'targetType', 'page', 'limit'];
        let variables = util.getDataStByKey(data, property);
        let params = { type: 'query', operation: 'getQuickReviewPresetList', variables, getData: 'docs, totalDocs, totalPages, page, limit' };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams).then(res => res.data.data[params.operation]).catch(e => e);
    };

    @action saveQuickReviewPreset = (data, cb) => {
        let property = ['id', 'data'];
        let variables = util.getDataStByKey(data, property);
        let params = { type: 'mutation', operation: 'saveQuickReviewPreset', variables, getData: 'data' };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams).then(res => res.data.data[params.operation]).catch(e => e);
    };

    @action deleteQuickReviewPreset = (data, cb) => {
        let property = ['id'];
        let variables = util.getDataStByKey(data, property);
        let params = { type: 'mutation', operation: 'deleteQuickReviewPreset', variables, getData: 'data' };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams).then(res => res.data.data[params.operation]).catch(e => e);
    };

    // ==================== 설문 리뷰 API ====================

    // 설문 리뷰 리스트 조회
    @action getSurveyReviewList = (data, cb) => {

        let property = ['store_id', 'shopNo', 'type', 'isActive', 'page', 'limit'];
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'query',
            operation: 'getSurveyReviewList',
            variables: variables,
            getData: 'docs, totalDocs, limit, page, nextPage, prevPage, totalPages, pagingCounter'
        };

        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }
            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };

    // 설문 리뷰 단건 조회
    @action getSurveyReview = (data, cb) => {

        let property = ['_id', 'store_id', 'shopNo'];
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'query',
            operation: 'getSurveyReview',
            variables: variables,
            getData: 'data'
        };

        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }
            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };

    // 설문 리뷰 트리 구조 조회
    @action getSurveyReviewTree = (data, cb) => {

        let property = ['store_id', 'shopNo', 'isActive'];
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'query',
            operation: 'getSurveyReviewTree',
            variables: variables,
            getData: 'data'
        };

        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }
            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };

    // 설문 리뷰 생성/수정
    @action updateSurveyReview = (data, cb) => {

        let property = ['_id', 'store_id', 'shopNo', 'type', 'item_ids', 'name', 'description', 'order', 'isActive', 'isCommon', 'options', 'settings', 'toggleActive'];
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'mutation',
            operation: 'updateSurveyReview',
            variables: variables,
            getData: 'data'
        };

        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }
            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };

    // 설문 리뷰 단건 삭제
    @action deleteSurveyReview = (data, cb) => {

        let property = ['_id', 'store_id', 'shopNo'];
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'mutation',
            operation: 'deleteSurveyReview',
            variables: variables,
            getData: 'data'
        };

        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }
            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };

    // 설문 리뷰 다건 삭제
    @action deleteSurveyReviews = (data, cb) => {

        let property = ['ids', 'store_id', 'shopNo'];
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'mutation',
            operation: 'deleteSurveyReviews',
            variables: variables,
            getData: 'data'
        };

        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }
            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };

    // 설문 리뷰 순서 변경
    @action updateSurveyReviewOrder = (data, cb) => {

        let property = ['store_id', 'shopNo', 'orders'];
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'mutation',
            operation: 'updateSurveyReviewOrder',
            variables: variables,
            getData: 'data'
        };

        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }
            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };

    // 설문 상품 그룹 리스트 조회
    @action getSurveyProductGroupList = (data, cb) => {

        let property = ['store_id', 'shopNo', 'limit', 'page', 'sort', 'searchParams'];
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'query',
            operation: 'getSurveyProductGroupList',
            variables: variables,
            getData: 'docs, totalDocs, limit, page, nextPage, prevPage, totalPages, pagingCounter, meta'
        };

        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(res.status === 200) {
                    if(typeof cb === 'function') {
                        cb(res.data.data[params.operation]);
                    }
                    else {
                        return res.data.data[params.operation];
                    }
                }

            })
            .catch(function (error) {
                console.log(error);
                return error;
            });
    };

    // 설문 상품 그룹 생성/수정
    @action updateSurveyProductGroup = (data, cb) => {
        if(data._id) data.id = data._id;
        let property = ['id', 'store_id', 'shopNo', 'surveyReview_id', 'parentProduct_ids', 'childProduct_ids', 'product_ids', 'name', 'type']
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'mutation',
            operation: 'updateSurveyProductGroup',
            variables: variables,
            getData: 'data'
        };
        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }

            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };

    // 설문 상품 그룹 삭제
    @action removeSurveyProductGroup = (data, cb) => {
        if(data._id) data.id = data._id;
        let property = ['id', 'store_id']
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'mutation',
            operation: 'removeSurveyProductGroup',
            variables: variables,
            getData: 'data'
        };
        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }

            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };

    // 설문 답변 통계 리스트 조회
    @action getSurveyAnswerStatsList = (data, cb) => {

        let property = ['store_id', 'shopNo', 'product_id', 'platformProductId', 'surveyReview_id', 'page', 'limit'];
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'query',
            operation: 'getSurveyAnswerStatsList',
            variables: variables,
            getData: 'data'
        };

        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }
            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };

    // 설문 답변 통계 요약 조회
    @action getSurveyAnswerStatsSummary = (data, cb) => {

        let property = ['store_id', 'shopNo', 'product_id', 'platformProductId', 'surveyReview_id'];
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'query',
            operation: 'getSurveyAnswerStatsSummary',
            variables: variables,
            getData: 'data'
        };

        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }
            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };

    // === 상품 리뷰 복사 ===
    @action getReviewsForCopy = (data, cb) => {
        let params = {
            type: 'query',
            operation: 'getReviewsForCopy',
            variables: data,
            getData: 'data'
        };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams)
            .then(res => {
                const out = res.data.data[params.operation];
                if (typeof cb === 'function') cb(out); else return out;
            })
            .catch(err => { if (typeof cb === 'function') cb(err); return err; });
    };

    @action getCopiedSourceMap = (data, cb) => {
        let params = {
            type: 'query',
            operation: 'getCopiedSourceMap',
            variables: data,
            getData: 'data'
        };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams)
            .then(res => {
                const out = res.data.data[params.operation];
                if (typeof cb === 'function') cb(out); else return out;
            })
            .catch(err => { if (typeof cb === 'function') cb(err); return err; });
    };

    @action runReviewCopy = (data, cb) => {
        let params = {
            type: 'mutation',
            operation: 'runReviewCopy',
            variables: data,
            getData: 'data'
        };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams)
            .then(res => {
                const out = res.data.data[params.operation];
                if (typeof cb === 'function') cb(out); else return out;
            })
            .catch(err => { if (typeof cb === 'function') cb(err); return err; });
    };

    @action listReviewCopyJobs = (data, cb) => {
        let params = {
            type: 'query',
            operation: 'listReviewCopyJobs',
            variables: data,
            getData: 'data'
        };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams)
            .then(res => {
                const out = res.data.data[params.operation];
                if (typeof cb === 'function') cb(out); else return out;
            })
            .catch(err => { if (typeof cb === 'function') cb(err); return err; });
    };

    @action getReviewCopyJob = (data, cb) => {
        let params = {
            type: 'query',
            operation: 'getReviewCopyJob',
            variables: data,
            getData: 'data'
        };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams)
            .then(res => {
                const out = res.data.data[params.operation];
                if (typeof cb === 'function') cb(out); else return out;
            })
            .catch(err => { if (typeof cb === 'function') cb(err); return err; });
    };

    @action deleteCopiedReviews = (data, cb) => {
        let params = {
            type: 'mutation',
            operation: 'deleteCopiedReviews',
            variables: data,
            getData: 'data'
        };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams)
            .then(res => {
                const out = res.data.data[params.operation];
                if (typeof cb === 'function') cb(out); else return out;
            })
            .catch(err => { if (typeof cb === 'function') cb(err); return err; });
    };
}
